import axios from 'axios';
import { 
  FETCH_PETS_FAILED,
  FETCH_PETS_SUCCESS, 
  FETCH_PET_OF_THE_WEEK_FAILED,
  FETCH_PET_OF_THE_WEEK_SUCCESS,
  TOGGLE_SPINNER,
} from '../mutation-types';

export const state = {
  all: [],
  petOfToday: null,
  isLoading: false,
};

export const mutations = {
  [FETCH_PETS_SUCCESS](state, posts) {
    state.all = posts;
  },

  [FETCH_PETS_FAILED](state) {
    state.all = [];
  },

  [FETCH_PET_OF_THE_WEEK_SUCCESS](state, post) {
    state.petOfToday = post;
  },

  [FETCH_PET_OF_THE_WEEK_FAILED](state) {
    state.petOfToday = null;
  },

  
  [TOGGLE_SPINNER](state) {
    state.isLoading = !state.isLoading;
  },
};

export const actions = {
  async fetch({ commit }) {
    try {
      const { data: { data } } = await axios.get('/api/pets');
      commit(FETCH_PETS_SUCCESS, data);
    } catch (e) {
      commit(FETCH_PETS_FAILED);
    }
  },

  async fetchPetOfToday({ commit }) {
    try {
      const { data: { data } } = await axios.get('/api/pets/today');
      commit(FETCH_PET_OF_THE_WEEK_SUCCESS, data);
    } catch (e) {
      commit(FETCH_PET_OF_THE_WEEK_FAILED);
    }
  },

  async accept({ dispatch, commit }, post) {
    try {
      dispatch('toggleSpinner');

      await axios.put(`/api/pets/accept/${post.id}`);
      await dispatch('fetch');

      dispatch('toast', 'Pet set.', { root: true });
    } catch(e) {
      console.log(e)
      dispatch('toast', { 
        message: 'Something went wrong.', 
        type: 'is-danger' 
      }, { root: true });
    } finally {
      dispatch('toggleSpinner');
    }
  },

  toggleSpinner({ commit }) {
    commit(TOGGLE_SPINNER);
  },
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/pets.js